var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "69531807-FA03-41C9-A7F1-F21AA4B81537_sharp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 630,
    height: 353,
    rx: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.2%",
    y: "-5.9%",
    width: "110.5%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.29914253   0 0 0 0 0.575556979   0 0 0 0 1  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[New]-Customer-Portal---Desktop---Logins---Forgot-ID---Error---Help",
    transform: "translate(-627.000000, -549.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "illustration_login",
    transform: "translate(104.000000, 217.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login_page_illustration_2",
    transform: "translate(63.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.151948,246.077047 L4.76721202,246.077047 C2.58454238,246.077047 0.806070826,244.298586 0.806070826,242.05618 C0.806070826,239.813773 2.58454238,238.035313 4.76721202,238.035313 L473.232788,238.035313 C475.415458,238.035313 477.193929,239.813773 477.193929,242.05618 C477.11309,244.221262 475.334618,246.077047 473.151948,246.077047 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.799999952,
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(405.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Agent",
    transform: "translate(185.000000, 213.000000)",
    fill: "#0A1F44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone-No.",
    transform: "translate(37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-phone",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4279021,10.4490611 L10.1690907,11.7414515 C9.38952446,11.3519909 5.51475346,9.27625892 4.14680722,5.86077318 L5.63501759,4.43748191 C5.86232514,4.22008723 5.93434379,3.93629865 5.90610907,3.65092449 C5.87483234,3.3351559 5.71522953,3.01565854 5.5123575,2.79682754 L5.51271164,2.79648854 C5.50678789,2.79009598 5.50055831,2.78415548 5.49408726,2.77863464 L3.00688811,0.315295429 L3.00732274,0.314859575 C2.99629621,0.303930941 2.98440043,0.294438997 2.97186076,0.286351435 C2.82883787,0.181859119 1.63410935,-0.624599752 0.916498743,1.04291544 C0.849953189,1.19756299 0.771318666,1.35280794 0.688273695,1.51677046 C-0.0852903569,3.04415099 -1.2187841,5.2822628 3.74168818,11.2442739 L3.74139843,11.244516 C3.74646904,11.2506018 3.75179719,11.2563325 3.75735066,11.2617242 C3.99716545,11.5345048 7.80357185,15.7791062 12.7736443,15.9990443 C13.2204542,16.0188192 14.0385561,15.7298797 14.7275787,15.3023851 C15.0920337,15.0762573 15.4259358,14.8094352 15.6574608,14.5262752 C15.9130668,14.2136868 16.049168,13.8770437 15.9836692,13.5406295 C15.9496238,13.3658357 15.8617495,13.1970308 15.7089719,13.038782 L13.1439122,10.38173 L13.1443468,10.3813103 C13.1318555,10.3683638 13.1181246,10.3572898 13.1035567,10.3481208 C12.9666505,10.2454526 12.1028793,9.65085064 11.4278931,10.4490774 L11.4279021,10.4490611 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSharp);
export default __webpack_public_path__ + "static/media/Phone_sharp.e4fd62460bbd166be983051600230be6.svg";
export { ForwardRef as ReactComponent };